import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CalcExchangeResponseViewModel, ExchangeCurrencyParams } from '../../../model/src/public-api';
import { isNullOrEmpty } from '../../../util/src/public-api';
import { AppConfig } from '../../config/app.config';
import { ExchangeRateService } from '../../core/services/exchange-rate.service';

/**
 * 金額顯示 Pipe
 *
 * @export
 * @class CurrencyExchangePipe
 * @implements {PipeTransform}
 * @description
 * 參數1: 案件幣別
 * 參數2: 換匯幣別
 * 參數3: 換匯日期(yyyy-MM-dd)
 */
@Pipe({
  name: 'currencyExg'
})
export class CurrencyExchangePipe implements PipeTransform {

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private exchangeService: ExchangeRateService,
    private appConfig: AppConfig) {

  }

  get envConfig(): any {
    return this.appConfig.getEnv();
  }

  transform(value: any, ...args: any[]): any {
    if (isNullOrEmpty(value)) {
      return of(null);
    }

    if (args.length < 1) {
      throw 'No parameters.'
    }
    const { currency, exchangeCurrency, exchangeDate, specifyExchangeRate, companyId, step, round } = args[0]
    const caseCurrencyFractionDigits = this.appConfig.getDecimalLengthByCurrencyCode(currency);
    const caseCurrencyFormat = this.appConfig.getNumberFormatByCurrencyCode(currency);
    const caseCurrencyExtension = this.appConfig.getCurrencyExtensionByCurrencyCode(currency);

    const req: ExchangeCurrencyParams = {
      amount: value,
      srcCurrency: currency,
      targetCurrency: exchangeCurrency,
      exchangeDate,
      specifyExchangeRate,
      companyId,
      step,
      round
    };

    if (isNullOrEmpty(caseCurrencyExtension)) {
      return of(this.formatExchangeResult(this.exchangeService.getDefaultExchangeResult(req)));
    } else {
      const observable = this.exchangeService.getExchangeResult(req)
        .pipe(map(x => this.formatExchangeResult(x)));

      return observable;
    }
  }

  private formatExchangeResult(result: CalcExchangeResponseViewModel): string {
    let str = '';
    const amountStr = result.amountList![0]?.formattedAmount ?? '';
    const currencyStr = result.currency ?? '';
    str = `${amountStr} ${currencyStr}`.trim();

    return str;
  }
}
